import React from 'react';
import { Box, Icon } from '@wegroup/design-system';

interface Props {
  isOpen: boolean;
  color?: string;
  onClick?: () => void;
}

const DropdownButton: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  color,
  onClick = () => null,
}) => {
  return (
    <Box
      transform={isOpen ? 'rotate(180deg)' : ''}
      onClick={onClick}
      transition="0.2s"
    >
      <Icon
        name="GeneralActionsChevronDownRounded"
        boxSize={7}
        color={{
          base: isOpen ? 'white' : 'primary.500',
          laptop: 'currentcolor',
        }}
      />
    </Box>
  );
};

export default DropdownButton;
